/* BamBam House: "Passar vel með" í körfu.
   Sækir sections/karfa-vidbot.liquid og setur undir vörurnar í körfuskúffunni og á körfusíðunni.
   Hvaða vörur birtast ræðst af metafield custom.karfa_vidbot á hverri vöru. */
(function () {
  var css = ''
    + '.karfa-vidbot{margin:1.6rem 0 0.8rem;padding:1.4rem 1.4rem 0.4rem;border:0.1rem solid rgba(167,151,187,0.45);border-radius:1.2rem;background:#fff;color:#2b2b2b;}'
    + '.karfa-vidbot .karfa-vidbot__title{margin:0 0 1rem;font-family:"ivypresto-display",serif !important;font-weight:100;font-size:1.9rem;line-height:1.3;letter-spacing:0;text-align:center;color:#2b2b2b;}'
    + '.karfa-vidbot__row{display:flex !important;align-items:center;gap:1.2rem;padding:1rem 0;border-top:0.1rem solid rgba(167,151,187,0.3);}'
    + '.karfa-vidbot__img{display:block !important;flex:none;width:6rem;height:6rem;border-radius:0.8rem;overflow:hidden;background:#f6f1fb;}'
    + '.karfa-vidbot__img img{display:block;width:100%;height:100%;object-fit:cover;}'
    + '.karfa-vidbot__info{flex:1;min-width:0;display:flex;flex-direction:column;align-items:flex-start;gap:0.3rem;}'
    + '.karfa-vidbot__name{font-size:1.3rem;line-height:1.3;color:#2b2b2b;text-decoration:none;}'
    + '.karfa-vidbot__price{font-size:1.3rem;line-height:1.3;color:#2b2b2b;opacity:0.75;}'
    + '.karfa-vidbot__tag{font-size:1.1rem;line-height:1.2;padding:0.3rem 0.8rem;border-radius:999px;background:#ede1ff;color:#2b2b2b;}'
    + '.karfa-vidbot__btn{flex:none;border:0;border-radius:999px;background:#2b2b2b;color:#fff;font-family:inherit;font-size:1.2rem;line-height:1;letter-spacing:0.06rem;padding:1.1rem 1.6rem;cursor:pointer;white-space:nowrap;}'
    + '.karfa-vidbot__btn[disabled]{opacity:0.5;cursor:default;}'
    + '#main-cart-items .karfa-vidbot{max-width:56rem;margin-left:auto;}';
  var style = document.createElement('style');
  style.setAttribute('data-karfa-vidbot-styles', '');
  style.textContent = css;
  document.head.appendChild(style);

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var html = null;
  var lastKey = null;
  var fetching = false;

  function targets() {
    var out = [];
    var drawer = document.querySelector('cart-drawer .drawer__cart-items-wrapper');
    if (drawer) out.push(drawer);
    var page = document.querySelector('#main-cart-items .js-contents');
    if (page && page.querySelector('.cart-item')) out.push(page);
    return out;
  }

  function cartKey() {
    var parts = [];
    var items = document.querySelectorAll('.cart-item');
    for (var i = 0; i < items.length; i++) {
      var link = items[i].querySelector('a[href]');
      var qty = items[i].querySelector('input.quantity__input');
      parts.push((link ? link.getAttribute('href') : '') + 'x' + (qty ? qty.value : ''));
    }
    return parts.join(',');
  }

  function place() {
    var list = targets();
    for (var i = 0; i < list.length; i++) {
      var slot = null;
      var kids = list[i].children;
      for (var k = 0; k < kids.length; k++) {
        if (kids[k].className === 'karfa-vidbot-slot') slot = kids[k];
      }
      if (!html) {
        if (slot) slot.parentNode.removeChild(slot);
        continue;
      }
      if (!slot) {
        slot = document.createElement('div');
        slot.className = 'karfa-vidbot-slot';
        list[i].appendChild(slot);
      }
      if (slot.getAttribute('data-key') !== lastKey) {
        slot.innerHTML = html;
        slot.setAttribute('data-key', lastKey);
      }
    }
  }

  function update() {
    if (!targets().length) return;
    var key = cartKey();
    if (key === lastKey && html !== null) { place(); return; }
    if (fetching) return;
    fetching = true;
    fetch(root + '?section_id=karfa-vidbot', { cache: 'no-store', headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (text) {
        var box = new DOMParser().parseFromString(text, 'text/html').querySelector('.karfa-vidbot');
        html = box ? box.outerHTML : '';
        lastKey = key;
        place();
      })
      .catch(function () { html = ''; lastKey = key; })
      .then(function () { fetching = false; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-karfa-add]') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true;
    var drawer = btn.closest('cart-drawer');
    var body = { items: [{ id: Number(btn.getAttribute('data-karfa-add')), quantity: 1 }] };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (!res || res.status) { btn.textContent = 'Uppselt'; return; }
        if (drawer && res.sections && drawer.renderContents) drawer.renderContents(res);
        else window.location.reload();
      })
      .catch(function () { btn.disabled = false; });
  });

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(update, 80);
  }

  update();
  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
})();
